import React, { useState } from 'react';
import { Box, Container, Typography, Button, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import bgHero1 from '../assets/images/bg-hero-2.webp';
import personHero2 from '../assets/images/person-hero-2.webp';
import ContactForm from './ContactForm';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

function Hero() {
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        backgroundImage: `url(${bgHero1})`,
        backgroundSize: { md: '100% 100%' },
        backgroundPosition: { xs: 'center top', md: 'center bottom' },
        backgroundRepeat: 'no-repeat',
        minHeight: { xs: 'auto', md: '800px' },
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        paddingBottom: { xs: '48px', md: '100px' },
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: {
            xs: 'linear-gradient(180deg, rgba(7,40,75,0.35) 0%, rgba(7,40,75,0.2) 60%, rgba(7,40,75,0) 100%)',
            md: 'none'
          },
          pointerEvents: 'none',
          zIndex: 1
        }
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 3, md: 6 }, flexDirection: { xs: 'column', md: 'row' }, paddingLeft: { xs: 0, md: 2 } }}>
          <Box sx={{ flex: 1, color: 'white', textAlign: { xs: 'center', md: 'left' } }}>
            <Typography 
              variant="h1" 
              component="h1" 
              sx={{ 
                mb: { xs: 2, md: 3 }, 
                fontWeight: 700,
                fontSize: { xs: '2.2rem', md: '4.5rem' },
                lineHeight: 1.1,
                color: '#b79b72',
                pt: { xs: 4, md: 0 }
              }}
            >
              LEARN CHINESE WITH WISDOM
            </Typography>
            <Typography
            variant="h1" 
            component="h1" 
            sx={{ 
              mb: { xs: 2, md: 3 }, 
              fontWeight: 700,
              fontSize: { xs: '2.2rem', md: '4.5rem' },
              lineHeight: 1.1,
              color: '#b79b72'
            }}>
              智汇中文 沟通世界
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                mb: { xs: 3, md: 4 }, 
                opacity: 0.95, 
                lineHeight: 1.7,
                fontSize: { xs: '1rem', md: '1.25rem' },
                maxWidth: { xs: 600, md: 'unset' },
                mx: { xs: 'auto', md: 'initial' }
              }}
            >
              Professional Mandarin teaching team, personalized learning programs, helping you master Mandarin skills easily in Singapore and worldwide while deeply understanding Chinese culture
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => setContactDialogOpen(true)}
              sx={{
                bgcolor: 'accent.main',
                color: 'white',
                px: { xs: 3, md: 6 },
                py: { xs: 1.25, md: 1.5 },
                fontSize: { xs: '1rem', md: '1.325rem' },
                width: { xs: '100%', sm: 'auto' },
                '&:hover': { 
                  bgcolor: 'accent.dark',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Free Trial
            </Button>
          </Box>
          
          <Box sx={{ 
            width: { xs: '70%', sm: '60%', md: '30%' },
            mt: { xs: 2, md: 0 },
            display: { xs: 'none', md: 'block' }
            }}
          >
            <img src={personHero2} alt="Professional Teacher"  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', margin: '0 auto' }} />
          </Box>
        </Box>
      </Container>

      {/* Contact Form Dialog */}
      <Dialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
        fullScreen={isSmallScreen}
        maxWidth="md"
        fullWidth
        keepMounted={false}
        disableEnforceFocus
        disableAutoFocus
        disableRestoreFocus
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: {xs: 2, md: 4},
            maxHeight: '90vh',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #07284b 0%, #9f2122 100%)',
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 2,
            px: 3
          }}
        >
          <Typography
            component="span"
            sx={{
              fontFamily: 'serif',
              fontWeight: 700,
              fontSize: { xs: '1.3rem', md: '1.5rem' }
            }}
          >
            Contact Us
          </Typography>
          <IconButton
            onClick={() => setContactDialogOpen(false)}
            sx={{
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            p: 0,
            '&::-webkit-scrollbar': {
              width: '8px'
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1'
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#9f2122',
              borderRadius: '4px'
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#8a1e1f'
            }
          }}
        >
          <Box sx={{ px: 4, py: { xs: 4, md: 8 } }}>
            <ContactForm />
          </Box>
        </DialogContent>
      </Dialog>
      
    </Box>
  );
}

export default Hero;
